<template>
  <!-- 左侧手机模板——详情页 -->
  <div class="doctor_base_contentL">
    <div v-if='meeting_data.back_menu_type==2' style="height: 44px;"></div>
    <div ref='changeDateStyle' class="DBL_data  DBL_phone_noPadding">

      <div class="DBL_data_title DBL_phone_marging">
        <div ref="my_bgc" class="DBL_data_titleT">
          <div class="DBL_data_titleTL">
            <img v-if="!specialist_task.head_path" src="@/assets/ex_nav.webp" alt="">
            <img v-if="specialist_task.head_path" :src="specialist_task.head_path" alt="">
          </div>
          <div class="DBL_data_titleTR">
            <div class="DBL_data_titleTRT">{{removeBracesContent(specialist_task.name)}}</div>
            <div class="DBL_data_titleTRB"><img width="12px" src="@/assets/auto_img/医院_hospital@2x (1).png"
                alt="">{{specialist_task.hospital_name}}</div>
          </div>
        </div>
        <div class="DBL_data_titleB"><img width="14px" src="@/assets/auto_img/未标题-1.png"
            alt="">{{meeting_data.meeting_name}}</div>
      </div>

      <div class="DBL_phone_T">

        <div class="DBL_phone_title">
          <div @click='DBL_phone_titleType=2'
            v-if="task_config.content_type&&task_config.content_type.indexOf('专家任务')!=-1"
            :class="{DBL_phone_titleTED :DBL_phone_titleType==2}" class="DBL_phone_titleT"
            :style="DBL_phone_titleType==2?'color:' + meeting_data.theme_color||'#1890ff':''">
            专家任务<span :style="'background:' + meeting_data.theme_color||'#1890ff'"></span></div>
          <div @click='DBL_phone_titleType=1'
            v-if="task_config.content_type&&task_config.content_type.indexOf('专家简介')!=-1"
            :class="{DBL_phone_titleTED :DBL_phone_titleType==1}" class="DBL_phone_titleT"
            :style="DBL_phone_titleType==1?'color:' + meeting_data.theme_color||'#1890ff':''">
            专家简介<span :style="'background:' + meeting_data.theme_color||'#1890ff'"></span></div>
        </div>

        <div v-if='DBL_phone_titleType==2&&task_config.content_type&&task_config.content_type.indexOf("专家任务")!=-1'
          class="phone_task">
          <div v-if="!task_config.is_date_navigation||task_config.is_date_navigation==1">
            <div class="DBL_data_tab">
              <div @click="changeDate(item.date,index)" v-for="(item,index) in specialist_task.task_data" :key="index"
                :class="{DBL_ckeck: changeDateNum==index}"
                :style="changeDateNum==index?'background:' + meeting_data.theme_color||'#1890ff':''"
                class="DBL_data_item">
                <span :style="changeDateNum==index?'color:' + '#fff':''">{{item.date}}</span>
              </div>
            </div>

            <div class="DBL_data_All">
              <div v-show="changeDateNum==index" v-for="(item,index) in specialist_task.task_data" :key="index"
                class="DBL_data_AllD">

                <div class="getTaskGroupsCss" v-for="(group,groupIndex) in getTaskGroups(item.list)"
                  :key="group.key || groupIndex">
                  <template v-if="group.isMerged">

                    <div v-if="group.live_title" class="DBL_data_DTitle title_base title_base_big">
                      <div class="DBL_data_DMsg_title">会场：</div>
                      <div class="DBL_data_DMsg">{{group.live_title}}</div>
                    </div>
                    <div v-if="group.address" class="DBL_data_DTitle title_base title_base_big">
                      <div class="DBL_data_DMsg_title">地点：</div>
                      <div class="DBL_data_DMsg">{{group.address}}</div>
                    </div>

                    <div v-for="(j,i) in group.items" :key="i" class="DBL_data_Data DBL_data_Data_BG">
                      <div v-if="j.module_title" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">环节：</div>
                        <div class="DBL_data_DMsg">{{j.module_title}}</div>
                      </div>
                      <div v-if="j.identity_title" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">角色：</div>
                        <div class="DBL_data_DMsg">{{j.identity_title}}</div>
                      </div>
                      <div v-if="j.task_list&&j.task_list[0]" class="DBL_data_DTitle task_list">
                        <div class="task_list_boxTitle">内容：</div>
                        <div class="task_list_box">
                          <div v-for="(item,index) in j.task_list" :key="index" class="task_item">
                            <div class="task_itemTime">{{item.begin_time}}-{{item.end_time}}</div>
                            <div class="task_itemTXT">{{item.task_title}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </template>

                  <div v-else class="DBL_data_AllD">
                    <div v-for="(j,i) in group.items" :key="i" class="DBL_data_Data">
                      <div v-if="j.live_title" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">会场：</div>
                        <div class="DBL_data_DMsg">{{j.live_title}}</div>
                      </div>
                      <div v-if="j.address" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">地点：</div>
                        <div class="DBL_data_DMsg">{{j.address}}</div>
                      </div>
                      <div v-if="j.module_title" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">环节：</div>
                        <div class="DBL_data_DMsg">{{j.module_title}}</div>
                      </div>
                      <div v-if="j.identity_title" class="DBL_data_DTitle title_base">
                        <div class="DBL_data_DMsg_title">角色：</div>
                        <div class="DBL_data_DMsg">{{j.identity_title}}</div>
                      </div>
                      <div v-if="j.task_list&&j.task_list[0]" class="DBL_data_DTitle task_list">
                        <div class="task_list_boxTitle">内容：</div>
                        <div class="task_list_box">
                          <div v-for="(item,index) in j.task_list" :key="index" class="task_item">
                            <div v-if="item.begin_time" class="task_itemTime">{{item.begin_time}}<span
                                v-if="item.end_time">-{{item.end_time}}</span></div>
                            <div class="task_itemTXT">{{item.task_title}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div v-if="task_config.is_date_navigation==2">

            <div v-for="(item,index) in specialist_task.task_data" :key="index" class="DBL_data_All">
              <div class="DBL_data_AllT"><img src="@/assets/auto_img/未标题-2.png" alt=""> {{item.date}}</div>

              <div class="getTaskGroupsCss" v-for="(group,groupIndex) in getTaskGroups(item.list)"
                :key="group.key || groupIndex">
                <template v-if="group.isMerged">

                  <div v-if="group.live_title" class="DBL_data_DTitle title_base title_base_big">
                    <div class="DBL_data_DMsg_title">会场：</div>
                    <div class="DBL_data_DMsg">{{group.live_title}}</div>
                  </div>
                  <div v-if="group.address" class="DBL_data_DTitle title_base title_base_big">
                    <div class="DBL_data_DMsg_title">地点：</div>
                    <div class="DBL_data_DMsg">{{group.address}}</div>
                  </div>

                  <div v-for="(j,i) in group.items" :key="i" class="DBL_data_Data DBL_data_Data_BG">
                    <div v-if="j.module_title" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">环节：</div>
                      <div class="DBL_data_DMsg">{{j.module_title}}</div>
                    </div>
                    <div v-if="j.identity_title" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">角色：</div>
                      <div class="DBL_data_DMsg">{{j.identity_title}}</div>
                    </div>
                    <div v-if="j.task_list&&j.task_list[0]" class="DBL_data_DTitle task_list">
                      <div class="task_list_boxTitle">内容：</div>
                      <div class="task_list_box">
                        <div v-for="(item,index) in j.task_list" :key="index" class="task_item">
                          <div class="task_itemTime">{{item.begin_time}}-{{item.end_time}}</div>
                          <div class="task_itemTXT">{{item.task_title}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                </template>

                <div v-else class="DBL_data_AllD">
                  <div v-for="(j,i) in group.items" :key="i" class="DBL_data_Data">
                    <div v-if="j.live_title" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">会场：</div>
                      <div class="DBL_data_DMsg">{{j.live_title}}</div>
                    </div>
                    <div v-if="j.address" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">地点：</div>
                      <div class="DBL_data_DMsg">{{j.address}}</div>
                    </div>
                    <div v-if="j.module_title" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">环节：</div>
                      <div class="DBL_data_DMsg">{{j.module_title}}</div>
                    </div>
                    <div v-if="j.identity_title" class="DBL_data_DTitle title_base">
                      <div class="DBL_data_DMsg_title">角色：</div>
                      <div class="DBL_data_DMsg">{{j.identity_title}}</div>
                    </div>
                    <div v-if="j.task_list&&j.task_list[0]" class="DBL_data_DTitle task_list">
                      <div class="task_list_boxTitle">内容：</div>
                      <div class="task_list_box">
                        <div v-for="(item,index) in j.task_list" :key="index" class="task_item">
                          <div v-if="item.begin_time" class="task_itemTime">{{item.begin_time}}<span
                              v-if="item.end_time">-{{item.end_time}}</span></div>
                          <div class="task_itemTXT">{{item.task_title}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
        <div v-if='DBL_phone_titleType==1&&task_config.content_type&&task_config.content_type.indexOf("专家简介")!=-1'
          class="phone_introduce">
          <p v-html='specialist_task.content'></p>
        </div>

      </div>
    </div>
    <backhome :baseData='meeting_data' :meeting_data="meeting_data" v-if="meeting_data.id!=meeting_data.home_page_id">
    </backhome>

  </div>

</template>

<script>
import backhome from '@/components/backHome.vue';
import { getSpecialistDec, } from '@/api/meetApi'
import { getWXConfig } from "@/api/login.js";
export default {
  components: { backhome },
  data() {
    return {
      DBL_phone_titleType: 1,
      changeDateNum: 0,
      meeting_data: {},
      specialist_task: {},
      task_config: {},
    }
  },
  mounted() {
    this.changeDetailStyle();
  },
  created() {
    this.getData();
    document.title = '与会专家'
  },
  methods: {
    changeDate(date, index) {
      this.changeDateNum = index;
    },
    async getData() {
      let data = await getSpecialistDec({ meeting_id: this.$route.query.meeting_id, specialist_id: this.$route.query.id })
      this.meeting_data = data.payload.meeting_data
      this.specialist_task = data.payload.specialist_task

      this.task_config = data.payload.task_config

      console.log(this.task_config);
      if (this.task_config.content_type.indexOf("专家任务") != -1) {
        this.DBL_phone_titleType = 2
      }
      if (this.task_config.content_type.indexOf("专家简介") != -1) {
        this.DBL_phone_titleType = 1
      }

      // if (this.task_config.content_type.length > 1) {
      //   this.DBL_phone_titleType = 2
      // } else {
      //   this.DBL_phone_titleType = 1
      // }
      setTimeout(() => {
        this.changeDetailStyle()
      }, 500)
      this.share()
    },

    removeBracesContent(str) {
      return str.replace(/ *\{[^}]*\}/g, '');
    },
    getTaskGroups(list) {
      if (!Array.isArray(list)) {
        return [];
      }

      const groups = [];
      const groupIndexMap = Object.create(null);

      list.forEach((item, index) => {
        const liveTitle = item && item.live_title ? item.live_title.trim() : '';
        const address = item && item.address ? item.address.trim() : '';

        if (!liveTitle) {
          groups.push({
            key: `task-${index}`,
            live_title: '',
            address,
            items: [item],
            isMerged: false,
          });
          return;
        }

        if (groupIndexMap[liveTitle] === undefined) {
          groupIndexMap[liveTitle] = groups.length;
          groups.push({
            key: `live-${groups.length}`,
            live_title: liveTitle,
            address,
            items: [item],
            isMerged: false,
          });
          return;
        }

        const group = groups[groupIndexMap[liveTitle]];
        group.items.push(item);
        if (!group.address && address) {
          group.address = address;
        }
        group.isMerged = true;
      });

      return groups;
    },
    changeDetailStyle() {
      console.log(this.task_config.detail_style);
      this.$refs.changeDateStyle.style.background = "unset";
      this.$refs.changeDateStyle.style.backgroundColor = "unset";
      this.$refs.my_bgc.style.background = "unset";

      if (this.task_config.detail_style == 1) {
        console.log(this.$refs.changeDateStyle)
        this.$refs.changeDateStyle.style.backgroundColor = this.meeting_data.background_color;
      }
      if (this.task_config.detail_style == 2) {
        console.log(this.$refs.changeDateStyle)
        this.$refs.changeDateStyle.style.background = 'url(' + this.meeting_data.background_img_path + ')';
      }
      if (this.task_config.detail_style == 3) {
        this.$refs.changeDateStyle.style.background = 'url(' + this.task_config.detail_style_img_path + ')';
      }
      if (this.task_config.detail_style == 4) {
        this.$refs.changeDateStyle.style.backgroundColor = "#fafafa";
      }

      if (this.task_config.personal_background_path) {
        this.$refs.my_bgc.style.background = 'url(' + this.task_config.personal_background_path + ')';
      } else {
        this.$refs.my_bgc.style.backgroundColor = "#fff";
      }

      if (this.meeting_data.background_color) {
        document.querySelectorAll('body')[0].style.backgroundColor = this.meeting_data.background_color
      }

    },
    async share() {
      // 判断是否有meeting_id，用于记录访问次数
      let data = null
      if (this.meeting_data && this.meeting_data.id) {
        data = await getWXConfig({ url: window.location.href, meeting_id: this.meeting_data.id })
      } else {
        data = await getWXConfig({ url: window.location.href })
      }
      let reg = /\\r\\n/ig
      // 优先使用自定义的分享配置，如果没有则使用大会得默认配置
      // 当所有参数都没有时，会在wxConfig.js中生成默认配置
      // 七个参数分别为（分享配置，聊天标题，聊天图片，聊天介绍，朋友圈标题，朋友圈图片，朋友圈介绍）
      // 分享链接在wxConfig.js中生成，为当前页面链接
      this.WXConfig.wxShowMenu(
        data.payload,
        this.specialist_task.name,
        this.meeting_data.wechat_share_img_path,
        this.specialist_task.hospital_name,
        this.specialist_task.name,
        this.meeting_data.wechat_share_img_path,
        this.specialist_task.hospital_name,
      );
    }


  }
}
</script>


<style lang="less" scoped>
.task_list_box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.task_list {
  display: flex;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #232323;
  text-align: left;
  font-style: normal;
  .task_list_boxTitle {
  }
  .task_item {
    flex: 1;
    border-bottom: 1px dashed #eff0f2;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }
  .task_item:last-child {
    border-bottom: 0 solid #000;
    padding-bottom: 0px;
    margin-bottom: 0;
  }
  .task_itemTime {
    margin-bottom: 3px;
    font-weight: 500;
    line-height: 19px;
    font-size: 14px;
    color: #232323;
  }
  .task_itemTXT {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #232323;
    text-align: left;
    font-style: normal;
  }
}
.DBL_data {
  min-height: 100vh;
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  .DBL_data_All {
    margin-bottom: 12px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    border: 1px solid #efefef;
    padding-bottom: 1px;
    .DBL_data_AllD {
      padding: 10px 0px;
      padding-bottom: 2px;
    }
    .DBL_data_DTitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #818181;
      line-height: 18px;
      text-align: left;
      margin-bottom: 8px;
      font-style: normal;
      .DBL_data_DMsg {
        color: #232323;
      }
    }
    .title_base {
      display: flex;
    }
    .title_base .DBL_data_DMsg {
      flex: 1;
    }
    .DBL_data_Data {
      // border-bottom: 1px solid #eff0f2;
      margin-bottom: 9px;
      padding: 0 12px;
    }
    .DBL_data_Data:last-child {
      // border-bottom: 0px solid #eff0f2;
      // margin-bottom: 0;
    }

    .getTaskGroupsCss {
      border-bottom: 1px solid #eff0f2;
    }

    .getTaskGroupsCss:last-child {
      border-bottom: 0px solid #eff0f2;
      // margin-bottom: 0;
    }
    .DBL_data_AllT {
      height: 36px;
      img {
        width: 14px;
        margin-right: 6px;
      }
      background: rgba(0, 0, 0, 0.03);
      display: flex;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 15px;
      color: #222222;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      padding: 0 12px;
      align-items: center;
    }
  }
  .DBL_data_tab {
    padding: 12px 0;
    padding-top: 0;
    width: 100%;
    white-space: nowrap;
    // overflow: auto;
    overflow: hidden;
    .DBL_data_item {
      margin-right: 12px;
      span {
        display: flex;
        height: 100%;
        align-items: center;
      }
      position: relative;
      display: inline-block;
      height: 26px;
      padding: 4px 7px;
      line-height: 12px;
      background: #f8f8f8;
      border: 1px solid #f4f4f4;
      border-radius: 4px;
      font-weight: 400;
      color: #818181;
      font-size: 14px;
      .DBL_data_itemIcon {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -5px;
        height: 5px;
        margin: auto;
      }
    }
  }
  padding: 12px;
  .DBL_data_title {
    overflow: hidden;
    margin-bottom: 12px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    border: 1px solid #f4f4f4;
    .DBL_data_titleT {
      padding: 12px;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
      background-size: 100% 100%;
      min-height: 104px;
      display: flex;
      align-items: center;
      .DBL_data_titleTL {
        width: 56px;
        height: 56px;
        border-radius: 56px;
        overflow: hidden;
        margin-right: 12px;
        img {
          width: 100%;
          min-height: 100%;
        }
      }
      .DBL_data_titleTR {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .DBL_data_titleTRT {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #232323;
        line-height: 22px;
        text-align: left;
        margin-bottom: 9px;
        font-style: normal;
      }
      .DBL_data_titleTRB {
        img {
          margin-right: 6px;
        }
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #232323;
        line-height: 17px;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
      }
    }
    .DBL_data_titleB {
      border-top: 1px solid #eff0f2;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #222222;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      display: flex;
      padding: 8px 12px;
      min-height: 40px;
      align-items: center;
      img {
        margin-right: 6px;
      }
    }
  }
}
.DBR_dc_btn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin-right: 24px;
  }
}
.ipaginationB_name {
  font-weight: 500;
  font-size: 15px;
  color: #222222;
}
.DBL_list_TAB {
  height: 48px;
  display: flex;
  .DBL_list_TAB_item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .ckecked {
      color: #1890ff;
    }
    .DBL_list_TABL_line {
      display: inline-block;
      width: 20px;
      border-radius: 2px;
      height: 2px;
      background-color: #1890ff;
      position: absolute;
      width: 20px;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 10px;
    }
  }
}
.doctor_title_box {
  display: flex;
  justify-content: space-between;
  :deep(.onSearchBox .ant-btn-primary) {
    background: #f5f7fa;
    border: 1px solid #e5e6eb;
    color: #7e8081;
    box-shadow: unset;
  }
}
.doctor_title_boxR {
  display: flex;
  button {
    margin-left: 10px;
  }
  .doc_name_title {
    display: flex;
    min-width: 480px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }
}
.doctor_base {
  padding: 24px;
}
.doctor_base_title {
  display: flex;
  padding: 4px;
  background: #f4f5f6;
  border-radius: 4px;
  width: 312px;
  justify-content: space-between;
  div {
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    border-radius: 2px;
  }
  .checked {
    color: #1890ff;
    background-color: #fff;
    font-weight: 500;
    font-size: 15px;
  }
}
.doctor_base_content {
  display: flex;
  margin-top: 24px;
  margin-bottom: 70px;
  width: 100%;
  .doctor_base_contentL {
    margin-right: 40px;
    width: 375px;
    min-height: 667px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
  }
  .doctor_base_contentR {
    .DBR_data_itemT_inp,
    .ant-input {
      width: 120px;
      color: #222222;
    }
    :deep(.ant-input) {
      color: #222222;
    }
    .ant-checkbox-wrapper {
      color: #222222;
    }
    .DBR_data_item {
      padding: 16px;
      font-weight: 400;
      font-size: 15px;
      color: #585858;
      height: 112px;
      background: #f9fafc;
      border-radius: 2px;
      margin-bottom: 12px;
      display: flex;
      flex-direction: column;
    }
    .DBR_data_item:last-child {
      margin-bottom: 0;
    }
    .DBR_data_title {
      margin-right: 12px;
    }
    .DBR_data_must {
      color: red;
    }
    .DBR_data_itemT {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
    .DBR_data_myimg {
      width: 160px;
      height: 90px;
    }
    .DBR_data {
      .DBR_data_item {
        display: flex;
      }
      padding-bottom: 24px;
      .DBR_data_add {
        width: 160px;
        margin-bottom: 16px;
        height: 40px;
        font-weight: 400;
        font-size: 12px;
        color: #222222;
        line-height: 17px;
        border-radius: 4px;
        border: 1px solid #e5e6eb;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    flex: 1;
    max-width: 560px;
    .DBR_B {
      border-bottom: 1px solid #eff0f2;
    }
    .DBR_title_boxBase {
      border-bottom: 1px solid #eff0f2;
    }
    .bottom_none {
      border-bottom: 0px solid #000;
    }
    .DBR_title_box {
      padding: 24px 0;
      display: flex;
      align-items: center;
    }
    .DBR_title_boxL {
      font-weight: 400;
      font-size: 15px;
      color: #222222;
    }
    .DBR_title_boxC {
      flex: 1;
      font-weight: 400;
      font-size: 14px;
      color: #86909d;
      margin-left: 12px;
    }
  }
  .DBL_list {
    // background: url("~@/assets/kv.jpg");
    background-size: 100% 100%;
    padding: 10px 12px;
    .DBL_list_inp {
      :deep(.ant-input) {
        background: #ffffff;
        border-radius: 20px;
      }
    }
    .DBL_list_All {
      background-color: #fff;
      .DBL_list_Base_RBig {
        position: absolute;
        height: 90%;
        right: -12px;
        top: 5%;
        font-weight: 400;
        font-size: 10px;
        color: #a9a9a9;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .DBL_list_BaseSelect {
        color: #232323;
      }
      position: relative;
      border: 1px solid #f1f3f4;
      border-radius: 12px;
      margin: 10px 0;
    }
    .DBL_list_Base {
      .DBL_list_BaseBig {
        position: absolute;
        left: 16px;
        top: 2px;
        font-weight: 400;
        font-size: 12px;
        color: #a9a9a9;
      }
      position: relative;
      height: 100%;
      padding: 0 16px;
      .DBL_list_item {
        .DBL_list_itemL {
          width: 56px;
          height: 56px;
          border-radius: 56px;
          overflow: hidden;
          margin-right: 12px;
        }
        .DBL_list_itemR {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .DBL_list_itemRT {
          font-weight: 600;
          font-size: 15px;
          color: #232323;
        }
        .DBL_list_itemRB {
          font-weight: 400;
          font-size: 12px;
          color: #888888;
        }
        display: flex;
        padding: 17px 0;
        height: 88px;
        border-bottom: 1px solid #f1f3f4;
      }
    }
  }
}
.noFlex {
  display: block;
}

.DBL_phone_noPadding {
  padding: 0;
  display: flex;
  flex-direction: column;

  .DBL_phone_T {
    padding: 12px;
    padding-top: 0;
    .phone_introduce {
      background: #ffffff;
      font-weight: 400;
      font-size: 15px;
      color: #222222;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.03);
      border-radius: 6px;
      border: 1px solid #efefef;
      padding: 12px;
    }
    .DBL_phone_title {
      display: flex;
      height: 48px;
      align-items: center;
    }
    .DBL_phone_titleT {
      display: flex;
      height: 48px;
      align-items: center;
      font-weight: 500;
      color: #8a94a3;
      font-size: 15px;
      position: relative;
      margin-right: 24px;
      span {
        opacity: 0;
        position: absolute;
        display: inline-block;
        bottom: 10px;
        left: 0;
        right: 0;
        width: 16px;
        height: 2px;
        background: #3185f7;
        border-radius: 2px;
        margin: auto;
      }
    }
    // .DBL_phone_titleT:first-child {
    //   color: #3185f7;
    //   span {
    //     opacity: 1;
    //   }
    // }
    .DBL_phone_titleTED {
      color: #3185f7;
      span {
        opacity: 1;
      }
    }
    flex: 1;
    border-radius: 12px 12px 0px 0px;

    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0)
    );
  }
}
.DBL_phone_marging {
  margin: 12px;
}

.doctor_base_contentL .DBL_data .DBL_data_All .DBL_data_Data_BG {
  background-color: rgba(0, 0, 0, 0.03);
  padding: 9px;
  margin: 9px;
  border-radius: 4px;
  padding-bottom: 1px;
}

.DBL_data .DBL_data_All .title_base_big {
  padding: 0 18px;
}

.DBL_data .DBL_data_All .title_base_big:first-child {
  padding-top: 9px;
}
</style>


<style>
.phone_introduce {
  text-align: justify;
}
.phone_introduce img {
  max-width: 100%;
}
.phone_introduce_textarea {
  border: 0px !important;
  background: #fff !important;
  font-size: 15px !important;
  color: #222 !important;
  padding: 0px !important;
}
</style>
